export default __webpack_public_path__ + "static/media/logo-autopass-for-insurance.4510382f.svg";